import 'whatwg-fetch'
import {API_URL} from '../constants/configValues'
import {
  SUB_CATEGORY_TEMPERATURE,
  SUB_CATEGORY_HUMIDITY,
  SUB_CATEGORY_V_AC_METER,
  SUB_CATEGORY_SMOKE,
  SUB_CATEGORY_DOOR,
  SUB_CATEGORY_MOTION,
  SUB_CATEGORY_LUMINARY,
  //SUB_CATEGORY_GLASS,
  //SUB_CATEGORY_GAS,
  SUB_CATEGORY_HEAT_EXCEED,
  //SUB_CATEGORY_BUTTON,
  SUB_CATEGORY_LAMP,
  SUB_CATEGORY_LAMP_COMPACT,
  SUB_CATEGORY_LAMP_SLEEP,
  SUB_CATEGORY_LAMP_TABLE,
  SUB_CATEGORY_LAMP_CEILLING,
  SUB_CATEGORY_LAMP_DECOR,
  SUB_CATEGORY_LAMP_CHANDELIER,
  SUB_CATEGORY_FAN_1,
  SUB_CATEGORY_FAN_2,
  SUB_CATEGORY_FAN_CEILLING,
  SUB_CATEGORY_OUTLET,
  SUB_CATEGORY_WATERING,
  SUB_CATEGORY_HEATER,
  SUB_CATEGORY_BELL,
  SUB_CATEGORY_ALARM_BELL,
  SUB_CATEGORY_DO_NOT_DISTURB,
  SUB_CATEGORY_CURTAIN,
  SUB_CATEGORY_AIR_CONTROLLER,
  SUB_CATEGORY_PUMP,
  SUB_CATEGORY_DOOR_IN_HOUSE,
  SUB_CATEGORY_TEMPERATURE_OUTSIDE,
  SUB_CATEGORY_HUMIDITY_OUTSIDE,
  SUB_CATEGORY_POWER_METER,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH,
  SUB_CATEGORY_POWER_METER_COUNTER,
  DEVICE_STATUS_STATE_ON,
  DEVICE_STATUS_STATE_OFF,
  DEVICE_STATUS_STATE_LOW,
  DEVICE_STATUS_STATE_DISCONNECTED,
  DEVICE_STATUS_STATE_NORMAL,
  DEVICE_STATUS_STATE_HIGH,
  DEVICE_STATUS_COLOR_ON,
  DEVICE_STATUS_COLOR_OFF,
  DEVICE_STATUS_COLOR_TOO_LOW,
  DEVICE_STATUS_COLOR_LOW,
  DEVICE_STATUS_COLOR_NORMAL,
  DEVICE_STATUS_COLOR_HIGH,
  DEVICE_STATUS_COLOR_TOO_HIGH,
  DEVICE_STATUS_AIN_STATE_TOO_LOW,
  DEVICE_STATUS_AIN_STATE_LOW,
  DEVICE_STATUS_AIN_STATE_NORMAL,
  DEVICE_STATUS_AIN_STATE_HIGH,
  DEVICE_STATUS_AIN_STATE_TOO_HIGH,
  DEVICE_STATUS_COLOR_DISCONNECTED,
  DEVICE_STATUS_METER_STATE_NORMAL,
  DEVICE_STATUS_METER_STATE_HIGH
} from '../constants/defaultValues'

const device = {
  fetchDeviceStatus(token, systemID, stationID) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/presentations/devices/${stationID}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchStationConfig(token, systemID, stationID) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/station-config-by-category/${stationID}`, {
        method: 'GET',
        headers: headerJson
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  postDeviceCommand(token, systemID, command) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/control-device`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(command)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  postReboot(token, systemID, reboot) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/reboot-smu`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(reboot)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  postSyncReq(token, systemID, sync) {
    const headerJson = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': "*",
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
      'Authorization': `Bearer ${token}`
    }
    return new Promise((resolve, reject) => {
      fetch(`${API_URL}/v1/systems/${systemID}/stations/sync-req`, {
        method: 'POST',
        headers: headerJson,
        body: JSON.stringify(sync)
      }).then(response => {
        if (response.ok) {
          const contentType = response.headers.get('Content-Type') || ''
          if (contentType.includes('application/json')) {
            response.json().then(json => {
              resolve(json)
            }).catch(error => {
              reject(error)
            })
          }
        } else {
          reject({status: response.status, statusText: response.statusText})
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  reduceStateDevices({reduceDevices}) {
    return new Promise((resolve, reject) => {
      const stateDevices = reduceDevices.map((dev) => {
        let text = ""
        let color = DEVICE_STATUS_COLOR_NORMAL
        let unit = ""
        let disconnected = false
        let index = 0
        switch (dev.SubCategory) {
          case SUB_CATEGORY_TEMPERATURE:
          case SUB_CATEGORY_TEMPERATURE_OUTSIDE:
            index = 3
            color = DEVICE_STATUS_COLOR_NORMAL
            unit = "°C"
            if (dev.State === DEVICE_STATUS_AIN_STATE_TOO_LOW) {
              color = DEVICE_STATUS_COLOR_TOO_LOW
              text = "Quá thấp"
            } else if (dev.State === DEVICE_STATUS_AIN_STATE_LOW) {
              color = DEVICE_STATUS_COLOR_LOW
              text = "Thấp"
            } else if (dev.State === DEVICE_STATUS_AIN_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_AIN_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Cao"
            } else if (dev.State === DEVICE_STATUS_AIN_STATE_TOO_HIGH) {
              color = DEVICE_STATUS_COLOR_TOO_HIGH
              text = "Quá Cao"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_HUMIDITY:
          case SUB_CATEGORY_HUMIDITY_OUTSIDE:
            index = 4
            unit = "%"
            if (dev.State === DEVICE_STATUS_STATE_LOW) {
              color = DEVICE_STATUS_COLOR_LOW
              text = "Thấp"
            } else if (dev.State === DEVICE_STATUS_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Cao"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_V_AC_METER:
            index = 8
            unit = "V"
            if (dev.State === DEVICE_STATUS_STATE_LOW) {
              color = DEVICE_STATUS_COLOR_LOW
              text = "Thấp"
            } else if (dev.State === DEVICE_STATUS_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Cao"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_POWER_METER:
            index = 4
            unit = "watt"
            if (dev.State === DEVICE_STATUS_METER_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
            } else if (dev.State === DEVICE_STATUS_METER_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_POWER_METER_DAY:
            index = 5
            unit = "kwh"
            if (dev.State === DEVICE_STATUS_METER_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
            } else if (dev.State === DEVICE_STATUS_METER_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_POWER_METER_MONTH:
            index = 6
            unit = "kwh"
            if (dev.State === DEVICE_STATUS_METER_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
            } else if (dev.State === DEVICE_STATUS_METER_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_POWER_METER_COUNTER:
            index = 7
            unit = "kwh"
            if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_LUMINARY:
            index = 9
            unit = "lux"
            if (dev.State === DEVICE_STATUS_STATE_LOW) {
              color = DEVICE_STATUS_COLOR_LOW
              text = "Thấp"
            } else if (dev.State === DEVICE_STATUS_STATE_NORMAL) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Bình thường"
            } else if (dev.State === DEVICE_STATUS_STATE_HIGH) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Cao"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_DOOR:
          case SUB_CATEGORY_DOOR_IN_HOUSE:
            index = 1
            if (dev.State === DEVICE_STATUS_STATE_ON) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Mở"
            } else if (dev.State === DEVICE_STATUS_STATE_OFF) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Đóng"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              disconnected = true
              text = "Mất kết nối"
            }
            break
          case SUB_CATEGORY_MOTION:
            index = 2
            if (dev.State === DEVICE_STATUS_STATE_ON) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Có"
            } else if (dev.State === DEVICE_STATUS_STATE_OFF) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Không"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              disconnected = true
              text = "Mất kết nối"
            }
            break;
          case SUB_CATEGORY_SMOKE:
          case SUB_CATEGORY_HEAT_EXCEED:
            index = 0
            if (dev.State === DEVICE_STATUS_STATE_ON) {
              color = DEVICE_STATUS_COLOR_HIGH
              text = "Có"
            } else if (dev.State === DEVICE_STATUS_STATE_OFF) {
              color = DEVICE_STATUS_COLOR_NORMAL
              text = "Không"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              disconnected = true
              text = "Mất kết nối"
            }
            break;
          case SUB_CATEGORY_LAMP:
          case SUB_CATEGORY_LAMP_TABLE:
          case SUB_CATEGORY_OUTLET:
          case SUB_CATEGORY_WATERING:
          case SUB_CATEGORY_BELL:
          case SUB_CATEGORY_ALARM_BELL:
          case SUB_CATEGORY_DO_NOT_DISTURB:
          case SUB_CATEGORY_FAN_1:
          case SUB_CATEGORY_FAN_2:
          case SUB_CATEGORY_FAN_CEILLING:
          case SUB_CATEGORY_LAMP_DECOR:
          case SUB_CATEGORY_LAMP_COMPACT:
          case SUB_CATEGORY_LAMP_CHANDELIER:
          case SUB_CATEGORY_LAMP_SLEEP:
          case SUB_CATEGORY_LAMP_CEILLING:
          case SUB_CATEGORY_HEATER:
          case SUB_CATEGORY_PUMP:
            index = 12
            if (dev.State === DEVICE_STATUS_STATE_ON) {
              color = DEVICE_STATUS_COLOR_ON
              text = "Bật"
            } else if (dev.State === DEVICE_STATUS_STATE_OFF) {
              color = DEVICE_STATUS_COLOR_OFF
              text = "Tắt"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_AIR_CONTROLLER:
            index = 10
            unit = "°"
            if (dev.State === DEVICE_STATUS_STATE_ON) {
              color = DEVICE_STATUS_COLOR_ON
              text = "Bật"
            } else if (dev.State === DEVICE_STATUS_STATE_OFF) {
              color = DEVICE_STATUS_COLOR_OFF
              text = "Tắt"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
          case SUB_CATEGORY_CURTAIN:
            index = 11
            if (dev.State === DEVICE_STATUS_STATE_ON) {
              color = DEVICE_STATUS_COLOR_ON
              text = "Mở"
            } else if (dev.State === DEVICE_STATUS_STATE_OFF) {
              color = DEVICE_STATUS_COLOR_OFF
              text = "Đóng"
            } else if (dev.State === DEVICE_STATUS_STATE_DISCONNECTED) {
              color = DEVICE_STATUS_COLOR_DISCONNECTED
              text = "Mất kết nối"
              disconnected = true
            }
            break;
        }
        if (dev.SubCategory === SUB_CATEGORY_AIR_CONTROLLER) {
          const index = (dev.Val >> 16) & 0x0f
          const temp = index === 0
            ? 16
            : index === 1
              ? 17
              : index === 2
                ? 18
                : index === 3
                  ? 19
                  : index === 4
                    ? 20
                    : index === 5
                      ? 21
                      : index === 6
                        ? 22
                        : index === 7
                          ? 23
                          : index === 8
                            ? 24
                            : index === 9
                              ? 25
                              : index === 10
                                ? 26
                                : index === 11
                                  ? 27
                                  : index === 12
                                    ? 28
                                    : index === 13
                                      ? 29
                                      : 30
          const mode = (dev.Val >> 24) & 0x07
          const modeLabel = mode === 0
            ? "Auto"
            : mode === 1
              ? "Cool"
              : mode === 2
                ? "Dry"
                : mode === 3
                  ? "Fan"
                  : "Heat"
          const wind = (dev.Val >> 27) & 0x03
          const windLabel = wind === 0
            ? "Auto"
            : wind === 1
              ? "Low"
              : wind === 2
                ? "Med"
                : "Hi"
          const swing = (dev.Val >> 29) & 0x07
          const swingLabel = swing === 0
            ? "Auto"
            : swing === 1
              ? "1"
              : swing === 2
                ? "2"
                : swing === 3
                  ? "3"
                  : "4"
          return {
            ...dev,
            Text: text,
            Color: color,
            Unit: unit,
            Disconnected: disconnected,
            Temp: temp,
            Mode: modeLabel,
            Wind: windLabel,
            Swing: swingLabel
          }
        } else {
          return {
            ...dev,
            Text: text,
            Color: color,
            Unit: unit,
            Disconnected: disconnected,
            Index: index
          }
        }
      })
      resolve(stateDevices)
    })
  },
  reduceRoomDevices({rawDevices, rooms}) {
    return new Promise((resolve, reject) => {
      const roomDevices = rawDevices.map((dev) => {
        const index = rooms.findIndex((room) => {
          return room.RoomId === dev.RoomId
        })
        const room = index > -1
          ? rooms[index]
          : {
            RoomId: 0,
            Name: "Default"
          }
        return {
          ...dev,
          RoomName: room.Name
        }
      })
      resolve(roomDevices)
    })
  }
}

export default device



// WEBPACK FOOTER //
// ./src/api/device.js